import { memo } from "react";

import { Divider } from "@/components/atoms/Divider";

/**
 * Item Separator View
 *
 * Renders a visual separator line between list items.
 * Provides consistent spacing and styling across list components.
 * @module components/ItemSeparator/ItemSeparatorView
 */
const ItemSeparatorView = () => (
  <Divider className="bg-surface-muted opacity-50" />
);

ItemSeparatorView.displayName = "ItemSeparatorView";

export default memo(ItemSeparatorView);
